var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo, useMemo } from 'react';
import { WithErrorHandler } from '../../components/WithErrorHandler';
import BaseModal from './baseModal';
var Index = function (props) {
    var titleRelate = useMemo(function () {
        return {
            mainTitle: typeof props.titleRelate !== 'undefined' && props.titleRelate.mainTitle || '预约试驾',
            btnMainTitle: typeof props.titleRelate !== 'undefined' && props.titleRelate.btnSubTitle || '立即预约',
            btnSubTitle: typeof props.titleRelate !== 'undefined' && props.titleRelate.btnMainTitle || '专业顾问给您安排线下试驾、体验车辆乘驾感受'
        };
    }, [JSON.stringify(props.titleRelate)]);
    return (React.createElement(BaseModal, __assign({}, props, { titleRelate: __assign({}, titleRelate) })));
};
export default WithErrorHandler(memo(Index));
